import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { LANDING } from "@/constants/testIds";

const faqs = [
  {
    q: "How is Key Legacy Protection different from a typical insurance broker?",
    a: "We specialize exclusively in owner-led businesses between 10 and 1,000 employees. We don't take override commissions from carriers, and we publish every quote we negotiate side-by-side so you know exactly what's on the table.",
  },
  {
    q: "We're a small team — are we too small to work with you?",
    a: "Our smallest active client has 6 employees, our largest 940. Group life and disability programs become available at 2 employees in most states. If we're not the right fit, we'll tell you immediately and refer you on.",
  },
  {
    q: "Can you replace our current broker mid-policy?",
    a: "Yes. A Broker of Record (BOR) letter takes about 10 days to process. You don't have to wait until renewal. Your premium and carrier don't change — only who services the policy.",
  },
  {
    q: "Which states are you licensed in?",
    a: "38 states including all major metros. If you operate in a state we're not licensed in, we partner with a licensed surplus lines broker so coverage placement is never blocked.",
  },
  {
    q: "How do you get paid?",
    a: "Standard carrier commissions, fully disclosed on every quote.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid={LANDING.faq}
      className="px-6 md:px-12 lg:px-24 py-24 md:py-32"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="label-eyebrow mb-4"><span className="text-accent">06</span> — FAQ</p>
          <h2 className="font-display text-4xl md:text-5xl h-tight font-medium">
            The questions{" "}
            <span className="italic font-light text-accent">owners ask</span> before they
            switch.
          </h2>
          <p className="mt-6 text-muted-foreground">
            Don&apos;t see yours below? Email{" "}
            <a
              href="mailto:JanayJones822@gmail.com"
              className="text-foreground underline underline-offset-4 hover:text-accent break-all"
            >
              JanayJones822@gmail.com
            </a>{" "}
            — we usually reply same-day.
          </p>
        </div>

        <div className="lg:col-span-8 lg:col-start-5">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                value={`item-${i}`}
                key={i}
                data-testid={LANDING.faqItem(i)}
                className="border-b border-border"
              >
                <AccordionTrigger className="text-left text-lg md:text-xl font-display font-medium hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6 pr-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
